import React from "react";

import { IconProps } from "fe-shared/src/types/common";

const NavArrowIcon = ({
  width = "24",
  height = "24",
  style,
  className,
  fillClassName,
  fillColor = "#27A83B",
  isRight = false,
}: IconProps & { isRight?: boolean }) => (
  <svg
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    style={{ ...style, transform: isRight ? "rotate(180deg)" : "" }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor!}
      className={fillClassName}
      d="M17.002 2.985a1.25 1.25 0 00-1.77 0l-8.31 8.31a.996.996 0 000 1.41l8.31 8.31c.49.49 1.28.49 1.77 0s.49-1.28 0-1.77l-7.24-7.25 7.25-7.25c.48-.48.48-1.28-.01-1.76z"
    />
  </svg>
);

export default NavArrowIcon;
